//@flow
import React, { useEffect, useLayoutEffect, useState, useRef } from 'react';
import Slider from 'react-slick';
import Dotdotdot from 'react-dotdotdot';
import RupeePinkIcon from 'assets/images/rupee-icon-pink.png';
import EnabledArrow from 'assets/images/Carausel-arrows-active.png';
import DisabledArrow from 'assets/images/Carausel-arrows-disabled.png';
import DollarPinkIcon from 'assets/images/Dollar-Icon.png';
import ArrowPinkDown from 'assets/images/Load-more-arrow-01.png';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  imageToDisplayOnClick: void,
  outletFoodCategory: Array<any>,
  selectedFoodCategoryValue: Object<any>,
};

export const MenuItems = (props: Props) => {
  const {
    imageToDisplayOnClick,
    outletFoodCategory,
    selectedFoodCategoryValue,
  } = props;
  // let height = false;

  const [height, setHeight] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);
  const [slider, setSlider] = useState();
  const [currentMenuCollageImage, setCurrentMenuCollageImage] = useState({
    originalImage:
      outletFoodCategory.length > 0 ? outletFoodCategory[0].listImageUrl : '',
    thumbnailImage:
      outletFoodCategory.length > 0
        ? outletFoodCategory[0].thumbnailListImageUrl
        : '',
    imageId: outletFoodCategory.length > 0 ? outletFoodCategory[0].id : '',
  });

  const [menuItemsData, setMenuItemsData] = useState(
    outletFoodCategory.length > 0 ? outletFoodCategory[0].menu : ''
  );

  useEffect(() => {
    if (
      selectedFoodCategoryValue &&
      outletFoodCategory &&
      outletFoodCategory.length > 0
    ) {
      outletFoodCategory.map((category, idx) => {
        if (selectedFoodCategoryValue.value === category.id) {
          const imageObject = {
            originalImage: category.listImageUrl,
            thumbnailImage: category.thumbnailListImageUrl,
            imageId: category.id,
          };
          imageToDisplayOnClick(imageObject);
          setCurrentMenuCollageImage(imageObject);
          setMenuItemsData(category.menu);
        }
      });
    }
  }, [selectedFoodCategoryValue]);
  useEffect(() => {
    if (outletFoodCategory && outletFoodCategory.length > 0) {
      const imageObject = {
        originalImage: outletFoodCategory[0].listImageUrl,
        thumbnailImage: outletFoodCategory[0].thumbnailListImageUrl,
        imageId: outletFoodCategory[0].id,
      };
      imageToDisplayOnClick(imageObject);
      setCurrentMenuCollageImage(imageObject);
      setMenuItemsData(outletFoodCategory[0].menu);
    }
  }, [outletFoodCategory]);

  const calculateWidth = () => {
    let parentEle = document.querySelector('.food-category-carousel');
    let parentWidth = parentEle && parentEle.offsetWidth;
    let childEle = parentEle && parentEle.getElementsByClassName('slick-slide');
    let collection = childEle ? childEle : [];
    let total_width = 0;
    for (let i = 0; i < collection.length; i++) {
      total_width = total_width + childEle[i].offsetWidth;
    }
    return parentWidth < total_width;
  };

  useEffect(() => {
    calculateWidth();
  }, []);

  useLayoutEffect(() => {
    let parentEle = document.querySelector('.menu-list');
    let parentHeight = parentEle && parentEle.offsetHeight;
    let childEle =
      parentEle && parentEle.getElementsByClassName('menu-item-details');
    let collection = childEle ? childEle : [];
    let total_height = 0;
    for (let i = 0; i < collection.length; i++) {
      total_height = total_height + childEle[i].offsetHeight;
    }
    return setHeight(parentHeight < total_height);
  }, [menuItemsData]);

  const settings = {
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    // arrows: true,
    swipeToSlide: false,
    speed: 1000,
    touchThreshold: 1000,
    draggable: calculateWidth(),
    beforeChange: (current, next) => setActiveSlide(next),
  };

  const selectedFoodCategory = (foodCategory, idx) => {
    const imageObject = {
      originalImage: foodCategory.listImageUrl,
      thumbnailImage: foodCategory.thumbnailListImageUrl,
      imageId: foodCategory.id,
    };
    // setActiveSlide(idx);
    imageToDisplayOnClick(imageObject);
    setCurrentMenuCollageImage(imageObject);
    setMenuItemsData(foodCategory.menu);
  };
  const renderFoodCategoryCarousel = () => {
    outletFoodCategory &&
      selectedFoodCategoryValue &&
      outletFoodCategory.sort(function(x, y) {
        return x.id === selectedFoodCategoryValue.value
          ? -1
          : y.id === selectedFoodCategoryValue.value
          ? 1
          : 0;
      });
    return (
      outletFoodCategory &&
      outletFoodCategory.map((foodCategory, idx) => (
        <div key={idx} onClick={() => selectedFoodCategory(foodCategory, idx)}>
          <h3
            style={{
              color:
                currentMenuCollageImage.imageId === foodCategory.id
                  ? '#ef7f7a'
                  : '#333333',
              borderBottom:
                currentMenuCollageImage.imageId === foodCategory.id
                  ? '2px solid #ef7f7a'
                  : '',
            }}
          >
            {foodCategory.name}
          </h3>
        </div>
      ))
    );
  };

  const onNextClick = () => {
    slider.slickNext();
  };

  const onPreviousClick = () => {
    slider.slickPrev();
  };

  const handleClick = () => {
    document.querySelector('.menu-list').scrollBy(0, 75);
  };

  const leftArrow = () => {
    if (activeSlide === 0) {
      return (
        <img
          src={DisabledArrow}
          alt="Left Arrow"
          style={{ cursor: 'default', pointerEvents: 'none' }}
        />
      );
    } else {
      return (
        <img src={EnabledArrow} alt="Left Arrow" onClick={onPreviousClick} />
      );
    }
  };
  const rightArrow = () => {
    const endOfSlide = outletFoodCategory.length - 1 === activeSlide;
    if (endOfSlide) {
      return (
        <img
          src={DisabledArrow}
          alt="Left Arrow"
          style={{ cursor: 'default', pointerEvents: 'none' }}
        />
      );
    } else {
      return <img src={EnabledArrow} alt="Left Arrow" onClick={onNextClick} />;
    }
  };
  const renderMenuItems = () => {
    return outletFoodCategory.length > 0 ? (
      menuItemsData &&
        menuItemsData.map((item, idx) => (
          <div
            key={idx}
            className={
              ' list-group-item list-group-item-action menu-item-details'
            }
            onMouseLeave={() => imageToDisplayOnClick(currentMenuCollageImage)}
            onMouseEnter={() =>
              imageToDisplayOnClick({
                originalImage: item.mediumImageUrl,
                thumbnailImage: item.thumbnailListImageUrl,
                imageId: item.id,
              })
            }
          >
            <div className={'menu-item-heading'}>
              <div className={'item-name'}>
                <h3>{item.name}</h3>
                <div className={'seperator'} />
              </div>
              <div className={'item-price'}>
                {item.price && item.currencyType === 'Rupee' && (
                  <img
                    src={RupeePinkIcon}
                    alt="Rupees"
                    className={'currency-icon'}
                  />
                )}
                {item.price && item.currencyType !== 'Rupee' && (
                  <img
                    src={DollarPinkIcon}
                    alt="Rupees"
                    className={'currency-icon'}
                  />
                )}
                <h3 className={'price-value'}>{item.price}</h3>
              </div>
            </div>
            <Dotdotdot clamp={2} tagName={'p'}>
              {item.description}
            </Dotdotdot>
          </div>
        ))
    ) : (
      <h3 style={{ height: '7vh', paddingLeft: '1.89394vw' }}>
        No Food Item At This Moment
      </h3>
    );
  };
  return (
    <div className={'menu-list-container'}>
      <h2 className={'menu-heading'}>Our Menu</h2>
      <div className={'food-category'}>
        <div className={'left-arrow'}>
          {outletFoodCategory.length > 0 && calculateWidth() ? leftArrow() : ''}
        </div>
        <div className={'food-category-carousel'}>
          <Slider ref={c => setSlider(c)} {...settings}>
            {renderFoodCategoryCarousel()}
          </Slider>
        </div>
        <div className={'right-arrow'}>
          {outletFoodCategory.length > 0 && calculateWidth()
            ? rightArrow()
            : ''}
        </div>
      </div>
      <div className={'list-group menu-list normal-scroll'}>
        {renderMenuItems()}
      </div>
      {menuItemsData.length > 0 && height ? (
        <div className={'down-arrow'} onClick={handleClick}>
          <img src={ArrowPinkDown} alt={'down'} />
        </div>
      ) : null}
    </div>
  );
};
